<div class="main">
  <app-header
    (cancel)="onCancelClick()"
   (next)="onNextClick()" 
    [nextAvailable]= false
    [cancelAvailable]="cancelAvailable"
    [isMobileApp]="isMobileApp"
  >
  </app-header>


  <div
    class="d-flex flex-column align-items-center justify-content-start main-top"
  >

    <!-- survey-->
    <!-- added px-4 so question doesn't run to edge of screen -->
    <div
      id="surveyElement"
      class="d-flex flex-row align-items-center justify-content-center m-auto "
      [class.m-auto]="!surveyCompleted"
    ></div>
    <!-- resources button  -->
    <div
      *ngIf="submitAvailable"
      class="d-flex flex-row align-items-center justify-content-center m-auto"
    >
    <div id="postSurvey">

    </div>

    <!--
      <button class="btn btn-info end-button" (click)="onEndClick()">
        End Survey & show help resources
      </button>
      -->
    </div>
    <!-- resources html -->

    <div
      *ngIf="surveyCompleted"
      class="d-flex flex-row align-items-center justify-content-center m-auto"
    >
      <app-help [requestID]="requestID"></app-help>
    </div>
  </div>
</div>


